import React from 'react';
import { FaTimes } from 'react-icons/fa';

const DeleteAlertModal = ({
  isOpen,
  currentMessage,
  onClose,
  onConfirm,
  isDeleting,
  error,
}) => {
  if (!isOpen) return null;

  const displayMessage = typeof currentMessage === 'string' ? currentMessage : '';

  return (
    <div
      className="admin-alerts-modal-overlay"
      onClick={isDeleting ? undefined : onClose}
      role="presentation"
    >
      <div
        className="admin-alerts-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-alert-modal-title"
      >
        <header className="admin-alerts-modal__header">
          <h2 id="delete-alert-modal-title">Delete Alert?</h2>
          <button
            type="button"
            className="admin-alerts-modal__close"
            onClick={onClose}
            disabled={isDeleting}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </header>

        <div className="admin-alerts-modal__body">
          <p className="admin-alerts-modal__text">
            This will remove the global alert currently shown to Tech Central users.
          </p>
          {displayMessage.trim().length > 0 && (
            <div className="admin-alerts-modal__message-quote">
              &ldquo;{displayMessage}&rdquo;
            </div>
          )}
          {error && <p className="admin-alerts-field-error">{error}</p>}
        </div>

        <footer className="admin-alerts-modal__footer">
          <button
            type="button"
            className="admin-alerts-btn admin-alerts-btn--secondary"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="admin-alerts-btn admin-alerts-btn--destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Alert'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default DeleteAlertModal;
